module.exports = __webpack_public_path__ + "static/media/vehicle3.3ed9564d.svg";